<div class="animate__animated " [ngClass]="{'animate__fadeIn': !loading}">
    <div [ngClass]="{'hidePlayer': !ipValid}">
        <nav class="barra-superior" [ngClass]="{'active':verControles}" (click)="controles_alternar()">
            <button type="button" class="atras" (click)="back()">
                <i class="fas fa-chevron-left mr-3"></i>
                <span>Atrás</span>
            </button>
        </nav>

        <div class="loadingParent" *ngIf="loading">
            <div class="col-12 mb-3 p-0 d-flex" style="place-content: center;">
                <div class="spinner-border mt-2 spinnerColor" style="width: 3rem; height: 3rem" role="status">
                </div>
            </div>
        </div>

        <div class="videoEnabled" [ngClass]="{'videoDisabled': loading}">
            <video #target class="video-js" id="playerjs" controls muted playsinline preload="none"
                allow="encrypted-media; autoplay"></video>
        </div>
    </div>

    <div *ngIf="!ipValid" class="restringido">
        <div class="tv-static"></div>
        <div class="gradient"></div>

        <div class="box mt-5">
            <a class="logo mb-5" routerLink="/home">
                <img src="../../assets/img/logos_cinemateca/SVG/logo_completo_blanco.svg" alt="Cinemateca" />
            </a>

            <h1>Oh no!</h1>
            <p>El material está restringido para esta región </p>

            <a routerLink="/home" class="btn mt-5 ">
                <i class="fas fa-backward mr-2"></i>
                Volver al inicio
            </a>
        </div>
    </div>
</div>